var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.702,
    height: 17.447,
    viewBox: "0 0 15.702 17.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(-4.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M19.33,27.979a.872.872,0,0,1-.872-.872V25.362a2.62,2.62,0,0,0-2.617-2.617H8.862a2.617,2.617,0,0,0-2.617,2.617v1.745a.872.872,0,0,1-1.745,0V25.362A4.362,4.362,0,0,1,8.862,21h6.979A4.367,4.367,0,0,1,20.2,25.362v1.745A.872.872,0,0,1,19.33,27.979Z",
    transform: "translate(0 -7.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M14.862,3A4.362,4.362,0,1,1,10.5,7.362,4.367,4.367,0,0,1,14.862,3Zm0,6.979a2.617,2.617,0,1,0-2.617-2.617A2.62,2.62,0,0,0,14.862,9.979Z",
    transform: "translate(-2.511 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.f5f468e11d44eb5d62e1b9c9b8c607ab.svg";
export { ForwardRef as ReactComponent };